
import { Vue, Component, Prop } from "vue-property-decorator";
import { required, maxLength, minLength } from "vuelidate/lib/validators";
import { AmCard, AmCardBody } from "@afe/amui/src/components/Card";
import { AmTypography } from "@afe/amui/src/components/Typography";
import { AmButton } from "@afe/amui/src/components/Button";
import { AmSpacing } from "@afe/amui/src/components/Spacing";
import {
  FormField,
  TextField,
  PasswordField,
  Preloader,
  FormError,
  FormBack,
  FormSubmit,
  PhoneField
} from "../components";
import { resetPasswordByPhone, RESET_PASSWORD_STEPS } from "../service";

@Component({
  validations: {
    phone_number: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(15)
    }
  },
  components: {
    AmCard,
    AmTypography,
    AmCardBody,
    FormField,
    TextField,
    PasswordField,
    AmSpacing,
    AmButton,
    Preloader,
    FormError,
    FormBack,
    FormSubmit,
    PhoneField
  }
})
export default class extends Vue {
  @Prop(Object) readonly config!: any;
  @Prop(Object) readonly formData!: any;

  phone_number = "";
  isError = false;
  loading = false;
  errorCode = "";

  async onSubmit() {
    this.$v.$touch();

    if (this.$v.$invalid) {
      return;
    }

    this.loading = true;
    this.isError = false;

    const data = {
      phone_number: this.phone_number,
      startupDelay: 0
    };

    resetPasswordByPhone({
      phone_number: this.phone_number
    })
      .then(response => {
        if (response.next === RESET_PASSWORD_STEPS.CODE_CONFIRM_STEP) {
          this.$emit("confirm", data);
        }
      })
      .catch(({ errors, data: responseData }) => {
        if (responseData && responseData.retryAfter) {
          data.startupDelay = responseData.retryAfter;
          this.$emit("confirm", data);
          return;
        }

        if (errors && errors.code) {
          this.errorCode = errors.code;
          this.loading = false;
          return;
        }

        this.$emit("confirm", data);
      });
  }
}
